import React, { Component } from 'react';
import {
  BrowserRouter,
  Route,
  Switch
} from 'react-router-dom';

import '../App.css';

import Header from './Header';
import Footer from './Footer';

import Home from './Home';
import Statistics from './Statistics';
import Help from './Help';
import Clothing from './Clothing';
import Meals from './Meals';
import Shelter from './Shelter';
import Contact from './Contact';
import NotFound from './NotFound';

class App extends Component {
  render() {
    return (
      <BrowserRouter basename="/lab/r-homeless">
        <div id="wrapper">
          <Header />

          <Switch>
            <Route exact path="/" component={Home} />
            <Route path="/statistics" component={Statistics} />
            <Route path="/help" component={Help} />
            <Route path="/clothing" component={Clothing} />
            <Route path="/meals" component={Meals} />
            <Route path="/shelter" component={Shelter} />
            <Route path="/contact" component={Contact} />
            <Route component={NotFound} />
          </Switch>

          <Footer />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;